<template>
  <div class="guest-views">
    <div class="guest-views__title">
      <h1 class="h1">Guestbook Views</h1>
      <h2 class="h2">
        Views in period: <span>{{ totalViews }}</span>
      </h2>
    </div>
    <div class="GuestViewsMain">
      <div class="LineGraphWrapper">
        <line-chart
          class="LineGraph"
          :chart-data="chartData"
          :options="chartOptions"
          :height="200"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "../../LineChart";
import countTotalMixin from "@/mixins/countTotalMixin";

export default {
  components: {
    LineChart,
  },
  mixins: [countTotalMixin],
  props: {
    statistics: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      chartData: {},
      chartOptions: {
        legend: {
          display: false,
        },
        tooltips: {
          intersect: false,
          displayColors: false,
          xPadding: 25,
          yPadding: 8,
          titleFontSize: 16,
          bodyFontSize: 20,
          bodyAlign: "center",
          titleAlign: "center",
          backgroundColor: "#48b9ba",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
      chartLabels: [],
      dataPoints: [],
    };
  },
  watch: {
    statistics(newValue) {
      if (newValue.length > 14) {
        this.handleMonth();
        this.populateData();
      } else {
        this.handleWeeks();
        this.populateData();
      }
    },
  },
  mounted() {
    if (this.statistics.length < 14 || this.statistics.length < 28) {
      this.handleWeeks();
      this.populateData();
    } else {
      this.handleMonth();
      this.populateData();
    }
  },
  computed: {
    totalViews() {
      return this.countTotal(this.statistics, "totalViews");
    },
  },
  methods: {
    populateData() {
      this.chartData = {
        labels: this.chartLabels,
        datasets: [
          {
            data: this.dataPoints,
            fill: false,
            borderColor: "#48b9ba",
            borderWidth: 5,
          },
        ],
        responsive: true,
        maintainAspectRatio: false,
      };
    },
    handleMonth() {
      let monthlyLabelsArray = [];
      let monthlyDataPoints = [];
      // two dimentional array, each inner array holds a period of time, finally concat them to make a single array
      for (let i = 0; i < this.statistics.length; i++) {
        if (i % 7 !== 0) {
          // Math.floor is used to figure out which array to push the data to
          if (i % 7 == 6) {
            // If the remainder is equal to 6, we know that it is the last day for that period of time
            monthlyLabelsArray[Math.floor(i / 7)].push(
              this.adjustDate(this.statistics[i][0])
            ); // Date
            monthlyLabelsArray[Math.floor(i / 7)] = monthlyLabelsArray[
              Math.floor(i / 7)
            ].join(" - "); // join the dates to one string
          }
          let viewAmount = Number(this.statistics[i][2].totalViews); // Convert to Integer
          monthlyDataPoints[Math.floor(i / 7)][0] += viewAmount; // Amount of Views
        } else {
          monthlyLabelsArray.push([this.adjustDate(this.statistics[i][0])]); // Date
          let viewAmount = Number(this.statistics[i][2].totalViews); // Convert to Integer
          monthlyDataPoints.push([viewAmount]); // Amount of Views
        }
      }
      this.chartLabels = monthlyLabelsArray;
      this.dataPoints = monthlyDataPoints.map((v) => {
        return v[0];
      }); //Fix from 6th of Jan 2020
    },
    handleWeeks() {
      let weeklyLabelsArray = [];
      let weeklyDataPoints = [];

      for (let i = 0; i < this.statistics.length; i++) {
        let viewAmount = Number(this.statistics[i][2].totalViews);
        weeklyLabelsArray.push(this.adjustDate(this.statistics[i][0]));
        weeklyDataPoints.push(viewAmount);
      }
      this.chartLabels = weeklyLabelsArray;
      this.dataPoints = weeklyDataPoints;
    },
    adjustDate(date) {
      date = date.split("-").reverse();
      return `${date[2].replace(/^0/, "")}/${date[1].replace(/^0/, "")}`;
    },
  },
};
</script>

<style scoped>
.guest-views__title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.guest-views__title .h2 {
  text-align: right;
}

.guest-views__title .h2 span {
  color: var(--primary);
}

@media screen and (min-width: 1440px) {
  .LineGraphWrapper {
    transform: scale(0.7, 0.7);
  }

  .guest-views__title {
    margin: 0px 200px 0px;
  }
}

/* .GuestViews {
    background-color: #ffffff;
    box-shadow: 0 3px 4px #ADADAD;
    border-radius: 3px;
    margin: 40px 0;
    padding: 10px 20px;
    text-align: center;
}
p {
    color: #707070;
    font-weight: 400;
    font-size: 48px;
    margin-top: 15px;
}
.GuestViewsMain {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}
.LineGraphWrapper {
    width: 60%;
    height: 100%;
}
.LineGraph {
    height: 100%;
    width: 100%;
}
.GuestViewsTotal {
    display: flex;
    flex-basis: 30%;
    flex-direction: column;
    background-color: #ffffff;
    box-shadow: 0 3px 4px #ADADAD;
    border-radius: 3px;
    padding: 10px 20px;
}


@media (max-width: 1025px) {
p {
    font-size: 32px;
    margin: 0;
}
.GuestViewsMain {
    padding: 0;
    padding-bottom: 20px;
}
.LineGraphWrapper {
    width: 65%;
}
.GuestViewsTotal {
    flex-basis: 30%;
    padding: 20px 10px;
}
}
@media (max-width: 769px) {
 .GuestViewsMain {
    display: flex;
    flex-direction: column;
}
.LineGraphWrapper {
    width: 85%;
}
.GuestViewsTotal {
    width: 100%;
    box-shadow: none;
}
} */
</style>
